import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class LocalUser {
  token?: string
  login?: string
  id?: number;
  expitedToken?: boolean = false;  // = new Date();
  

}